/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.collapsable[_ngcontent-%COMP%]{display:inline-block;border-radius:30px;padding:.3em .3em;font-size:11px;cursor:pointer}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdHJhdmlzL2J1aWxkL2luc3BpcmVoZXAvcmVjb3JkLWVkaXRvci9zcmMvYXBwL211bHRpLWVkaXRvci9qc29uLXRyZWUvb2JqZWN0LW5vZGUvb2JqZWN0LW5vZGUuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS90cmF2aXMvYnVpbGQvaW5zcGlyZWhlcC9yZWNvcmQtZWRpdG9yL3NyYy9hcHAvbXVsdGktZWRpdG9yL2pzb24tdHJlZS9vYmplY3Qtbm9kZS9vYmplY3Qtbm9kZS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/$$_gendir/app/multi-editor/json-tree/object-node/object-node.component.scss.shim.ngstyle.ts